import { call, put } from 'redux-saga/effects';
import { setDefaultRingtone } from '../../../state/audioDevice/audioDeviceSlice';
import { setRingtone } from '../../../utils/audioUtils';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { saveDefaultRingtone } from '../../../browser/storage';

export function* changeRingtoneSaga(action) {
    try {
        const ringtoneId = action.payload;
        const success = yield call(setRingtone, ringtoneId);
        
        if (success) {
            yield call(saveDefaultRingtone, ringtoneId);
            yield put(setDefaultRingtone(ringtoneId));
            yield put(showSnackbar({
                message: 'Ringtone changed successfully',
                severity: 'success'
            }));
        } else {
            throw new Error('Invalid ringtone selection');
        }
    } catch (error) {
        console.error('Error changing ringtone:', error);
        yield put(showSnackbar({
            message: 'Failed to change ringtone',
            severity: 'error'
        }));
    }
}